export default __webpack_public_path__ + "static/media/1xCada15dias.98e06889.svg";